module.exports = __webpack_public_path__ + "img/Small-Semi-Elliptical-Attachment-L-41.8ac7de88.png";